export default __webpack_public_path__ + "static/media/slider-unraf-5.33da9a6a.jpg";